import React from 'react';
import { Tooltip, Typography } from '@mui/material';

/** API timestamps are UTC but often lack a zone suffix; without one the browser would read them as local time. */
export function parseServerTime(value: string): Date {
  return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);
}

export function timeAgo(iso: string | Date, now = Date.now()): string {
  const t = typeof iso === 'string' ? parseServerTime(iso).getTime() : iso.getTime();
  if (Number.isNaN(t)) return '';
  const s = Math.round((now - t) / 1000);
  if (s < 0) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 48) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

/** "5 min ago", with the full local date and time on hover. */
export const RelativeTime: React.FC<{ value?: string | null; variant?: 'body2' | 'caption' }> = ({ value, variant = 'body2' }) => {
  if (!value) return null;
  return (
    <Tooltip title={parseServerTime(value).toLocaleString()}>
      <Typography component="span" variant={variant} sx={{ whiteSpace: 'nowrap' }}>
        {timeAgo(value)}
      </Typography>
    </Tooltip>
  );
};
